import { render, staticRenderFns } from "./AdminGraphs.vue?vue&type=template&id=c9860638&"
import script from "./AdminGraphs.vue?vue&type=script&lang=js&"
export * from "./AdminGraphs.vue?vue&type=script&lang=js&"
import style0 from "./AdminGraphs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports